import { EnumProjectType } from '../enums';
import { FotoRequest } from './FotoRequest';

export class ProjectDataModel {
  /**Название */
  Name: string;
  /**Изображение */
  Image: FotoRequest;
  /**Разрешен ли импорт с weeek */
  WeeekEnable: boolean;
  /**Статус проекта */
  Status: EnumProjectType;

  constructor(obj?: Partial<ProjectDataModel>) {
    Object.assign(this, obj);
  }
}
